import { useState } from 'react';
import SectionHeader from './SectionHeader.jsx';

const services = [
  {
    number: '01',
    icon: '\u{1F3DB}\uFE0F',
    glyph: 'crosshair',
    title: 'Architectural Strategy',
    items: ['Concept development', 'Land potential analysis', 'Layout optimization'],
  },
  {
    number: '02',
    icon: '\u{1F4D0}',
    glyph: 'asterisk',
    title: 'Feasibility & Planning',
    items: ['FSI utilization', 'Financial feasibility', 'Product mix strategy'],
  },
  {
    number: '03',
    icon: '\u{1F4CA}',
    glyph: 'diamond',
    title: 'Capital Structuring',
    items: ['Investment planning', 'ROI modeling', 'Deal structuring'],
  },
  {
    number: '04',
    icon: '\u{1F50D}',
    glyph: 'stack',
    title: 'Market Intelligence',
    items: ['Demand analysis', 'Pricing strategy', 'Target audience mapping'],
  },
];

function ServicesSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="services" data-section className="section-services fade-up">
      <div className="section-wrap services-layout">
        <div className="services-copy">
          <SectionHeader
            label="What We Do"
            title="Architecture-Led Services"
            subtitle="Design is not an outcome - it is the foundation of every financial decision."
          />
        </div>

        <div className="services-accordion" role="list">
          {services.map((service, index) => {
            const isOpen = openIndex === index;
            const panelId = `service-panel-${index}`;
            const buttonId = `service-trigger-${index}`;

            return (
              <article
                key={service.title}
                className={`service-accordion-item${isOpen ? ' open' : ''}`}
                role="listitem"
              >
                <button
                  id={buttonId}
                  type="button"
                  className="service-trigger"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex((currentIndex) => (currentIndex === index ? -1 : index))}
                >
                  <span className="service-trigger-main">
                    <span className="service-glyph" aria-hidden="true">
                      <ServiceGlyph glyph={service.glyph} />
                    </span>
                    <span className="service-heading">
                      <span className="service-title">{service.title}</span>
                    </span>
                  </span>
                  <span className="service-toggle" aria-hidden="true">
                    {isOpen ? '\u2212' : '+'}
                  </span>
                </button>

                <div
                  id={panelId}
                  className="service-panel"
                  role="region"
                  aria-labelledby={buttonId}
                >
                  <div className="service-panel-inner">
                    <ul className="service-points">
                      {service.items.map((item, itemIndex) => (
                        <li key={item} className="service-point">
                          <span className="service-point-index">0{itemIndex + 1}</span>
                          <span className="service-point-copy">{item}</span>
                          <span className="service-point-arrow" aria-hidden="true">
                            &rarr;
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ServiceGlyph({ glyph }) {
  switch (glyph) {
    case 'crosshair':
      return (
        <svg viewBox="0 0 28 28" focusable="false">
          <path d="M14 4L22 9V19L14 24L6 19V9L14 4Z" />
          <path d="M14 9v10M10 12l4-3 4 3M10 16l4 3 4-3" />
        </svg>
      );
    case 'asterisk':
      return (
        <svg viewBox="0 0 28 28" focusable="false">
          <path d="M14 4a10 10 0 1 1 0 20a10 10 0 1 1 0-20Z" />
          <path d="M8 14h12M14 8v12M10 10l8 8M18 10l-8 8" />
        </svg>
      );
    case 'diamond':
      return (
        <svg viewBox="0 0 28 28" focusable="false">
          <path d="M14 4l8 6-8 14L6 10l8-6Z" />
          <path d="M10 11h8M12 15h4M14 4v20" />
        </svg>
      );
    case 'stack':
      return (
        <svg viewBox="0 0 28 28" focusable="false">
          <path d="M7 6h14M7 14h14M7 22h14" />
          <path d="M10 6v16M18 6v16M14 10v8" />
        </svg>
      );
    default:
      return null;
  }
}

export default ServicesSection;
